var map = {
	"./en/about.json": 1240,
	"./en/footer.json": 3288,
	"./en/header.json": 7462,
	"./en/notFound.json": 3776,
	"./pt-br/LGPD.json": 7444,
	"./pt-br/about.json": 4662,
	"./pt-br/certifications.json": 8682,
	"./pt-br/contactUs.json": 879,
	"./pt-br/cookieBallon.json": 3287,
	"./pt-br/cookiePolicy.json": 6529,
	"./pt-br/cubage.json": 448,
	"./pt-br/fleet.json": 8355,
	"./pt-br/footer.json": 9106,
	"./pt-br/frequentlyAsked.json": 496,
	"./pt-br/header.json": 9516,
	"./pt-br/history.json": 2547,
	"./pt-br/home.json": 7990,
	"./pt-br/loadProfile.json": 7194,
	"./pt-br/notFound.json": 5758,
	"./pt-br/notices/2025/05/braspress-air-cargo–inicia–oficialmente-as–operacoes.json": 9344,
	"./pt-br/notices/2025/12/braspress-air-cargo-completa-6-meses-de-operacoes.json": 8529,
	"./pt-br/notices/2026/06/___cancel_braspress-air-cargo-ira-iniciar-operacao-noturna.json": 3534,
	"./pt-br/ourStores.json": 5647,
	"./pt-br/press.json": 4280,
	"./pt-br/privacyPolicy.json": 6889,
	"./pt-br/questions.json": 9010,
	"./pt-br/regulations.json": 1070,
	"./pt-br/securityRelprev.json": 1835,
	"./pt-br/services.json": 3661,
	"./pt-br/workWithUs.json": 3024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3486;